import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from "rxjs";
import { ToastrService } from 'ngx-toastr';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { DashboardTableService } from 'src/service/dashboard.service';
import { DashboardListTableService } from 'src/service/dashboard-list.service';

import { ApplicationConfigService } from 'src/service/application-config.service';
import { AzureAuthService } from 'src/service/azure-auth.service';

import { Dashboard,DashboardList,DashboardListItem, SiteType } from 'src/api/models';
import { CustomerService,DashboardService,DashboardListService, SiteTypeService } from 'src/api/services';


@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.css']
})
export class DashboardsComponent implements OnInit {
  @ViewChild("addDashboard", { static: false }) addDashboard: ModalDirective;
  @ViewChild("addDashboardList", { static: false }) addDashboardList: ModalDirective;

 //public customer : CustomerDashboards = {} as CustomerDashboards;
  public dashboard : Dashboard = {} as Dashboard;
  public categories : string[];
  public category : string;
  public newDashboard: Dashboard;
  public newDashboardList: DashboardList;
  public sourceDashboardList: DashboardListItem[];
  public editDashboardList: boolean;
  public siteTypes: SiteType[];
  public trash: [];
  public remoteData: Observable<any[]>;
  public listRemoteData: Observable<any[]>;

  constructor(
    private app: ApplicationConfigService,
    public azureAuthService: AzureAuthService,
    private router: Router,
    public siteTypeService: SiteTypeService,
    public service: DashboardTableService,
    public listservice: DashboardListTableService,
    public dashboardService: DashboardService,
    public dashboardListService: DashboardListService,
    public customerService: CustomerService,
    private toasterService: ToastrService
    ) { 
    this.remoteData = this.service.remoteData;
    this.listRemoteData = this.listservice.remoteData;
    app.customerChanged$.subscribe(cid => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {   
    /*if (this.azureAuthService.isAdmin()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => {           
          this.app.customers = c.filter(c=>c.active);          
        });
      }
    } */
    this.siteTypeService.SiteTypeGetAll(this.app.customerId ?? 0).subscribe(s => {
      this.siteTypes = s;
    });

    if (this.app.customerId == null) {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }
    if (this.app.customerId){
      this.service.get(this.app.customerId);
      this.listservice.get(this.app.customerId);
      this.dashboardService.DashboardGetCategories(this.app.customerId).subscribe(c => this.categories = c);
    }
  }

  public getSiteType(dashboardId: number) : SiteType {
    const dashboard = this.service.available.find(d => d.dashboardId == dashboardId);
    return this.siteTypes.find(s => s.siteTypeCode == dashboard.siteType);
  }
  
  public filterCategory(category){
    this.category = category;
    this.service.filterCategory(category);
    //this.treeGrid.filter("category", category, IgxStringFilteringOperand.instance().condition('contains'));
  }
  
  public clearFilterCategory(){
    this.category = null;
    //this.service.filter
    //this.treeGrid.clearFilter("category");
  }

  public doSearch(){
    this.service.filterSearch(this.service.searchFilter);
  }

  public changeCustomer(){
    console.log("Dashboards.ChangeCustomer()");
    if (this.app.customerId){
      this.service.get(this.app.customerId);
      this.dashboardService.DashboardGetCategories(this.app.customerId).subscribe(c => this.categories = c);
    }
  }

  public makeFavourite(dashboard){
    this.dashboardService.DashboardMakeFavourite(dashboard.dashboardId).subscribe(r => {
      dashboard.isFavourite = true;
      this.toasterService.success('Favourite Set');
    }, err =>{
      this.toasterService.error('Favourite Not Set');
    });
  }

  public removeFavourite(dashboard){
    this.dashboardService.DashboardRemoveFavourite(dashboard.dashboardId).subscribe(r => {
      dashboard.isFavourite = false;
      this.toasterService.success('Favourite Removed');
    }, err =>{
      this.toasterService.error('Favourite Not Removed');
    });
  }

  public showAddDashboard(){
    this.newDashboard = {} as Dashboard;
    this.addDashboard.show();
  }

  public closeAddDashboard(){
    this.addDashboard.hide();
  }

  public addNewDashboard(){
    this.service.add(this.app.customerId, this.newDashboard).subscribe(d => {
      this.toasterService.success('New Dashboard Created');
      this.router.navigate(['/dashboard/' + d.dashboardId]);
    });
  }

  public shareDashboard(dashboard: Dashboard){
    dashboard.published = true;
    this.dashboardService.DashboardUpdateDashboardDetails(dashboard).subscribe(r => this.toasterService.success('Shared'), e => {
      dashboard.published = false;
      this.toasterService.error("Failed to Share")
    });
  }

  public showAddDashboardList(){
    this.newDashboardList = {} as DashboardList;
    this.newDashboardList.dashboards = [];
    this.newDashboardList.customerId = this.app.customerId;
    this.editDashboardList = false;
    this.trash = [];
    this.sourceDashboardList = [];
    this.service.availableDashboards.forEach(val =>{
      (val as any).dashboard = this.service.available.find(d => d.dashboardId == val.dashboardId);
      if ((val as any).dashboard.siteType != null && (val as any).dashboard.siteType != ""){
        (val as any).siteType = this.siteTypes.find(st => st.siteTypeCode == (val as any).dashboard.siteType)
      }
      this.sourceDashboardList.push(val)
    });
    this.addDashboardList.show();
  }

  public publicUrl: string;
  
  public generatePublishedCode(){
    this.publicUrl = this.getPublishedCode(this.newDashboardList);
  }

  public getPublishedCode(dashboardList){
    var url = document.baseURI;
    var ext = "";
    return `${url}#/public/dashboard-list/${dashboardList.publishedIdentifier}`;
  }

  public canPublishToPublic(){
    if (this.newDashboardList){
      for (let d of this.newDashboardList.dashboards){
        if (!d.public){
          return false;
        }
      }
    }
    return true;
  }

  public publishToPublicDashboard(){
    this.dashboardListService.DashboardListPublishToPublic(this.newDashboardList.dashboardListId).subscribe(r => {
      if (r){
        this.showEditDashboardList(this.newDashboardList.dashboardListId);
      }
    }, e => {
      this.toasterService.error("Failed to Publish");
    });
  }

  public unPublishToPublicDashboard(){
    this.dashboardListService.DashboardListUnPublishToPublic(this.newDashboardList.dashboardListId).subscribe(r => {
      if (r){
        this.showEditDashboardList(this.newDashboardList.dashboardListId);
      }
    }, e => {
      this.toasterService.error("Failed to UnPublish");
    });
  }

  public showEditDashboardList(id: number){
    this.dashboardListService.DashboardListGetDashboardList({customerId: this.app.customerId, id: id}).subscribe(dl => {
      this.newDashboardList = dl;
      this.editDashboardList = true;
      this.trash = [];
      const dashboardList: DashboardListItem[] = [];
      this.service.availableDashboards.forEach(val =>{
        (val as any).dashboard = this.service.available.find(d => d.dashboardId == val.dashboardId);
        if ((val as any).dashboard.siteType != null && (val as any).dashboard.siteType != ""){
          (val as any).siteType = this.siteTypes.find(st => st.siteTypeCode == (val as any).dashboard.siteType)
        }
        dashboardList.push(val)
      });
      if (dl.publishedBy != null){
        this.generatePublishedCode();
      }
      if (this.newDashboardList.dashboards == null){
        this.newDashboardList.dashboards = [];
      }     
      this.sourceDashboardList = []; 
      // this.sourceDashboardList is the list of dashboards that can be added.
      // this.newDashboardList.dashboards is the list of dashboard that have been added and need to be sortable.
      //this.sourceDashboardList = dashboardList;
  
        dashboardList
        .filter(d => {
          const dashboard = this.newDashboardList.dashboards.find(dd => dd.dashboardId == d.dashboardId)
          const detail = dashboardList.find(dd => d.dashboardId == dd.dashboardId);
          if (dashboard){
            (dashboard as any).dashboard = (detail as any).dashboard;
            (dashboard as any).siteType = (detail as any).siteType;
          }
          return dashboard == null || (dashboard as any).siteType != null;
        })
        .forEach(val => this.sourceDashboardList.push(Object.assign({}, val)));
      console.log("Show Dashboard list", this.sourceDashboardList);
      this.addDashboardList.show();
    });    
  }  

  public closeAddDashboardList(){
    this.addDashboardList.hide();
  }

  public addNewDashboardList(){
    this.listservice.add(this.app.customerId, this.newDashboardList).subscribe(d => {
      this.toasterService.success('New Dashboard List Created');
      this.listservice.get(this.app.customerId);
    });
  }

  public updateDashboardList(){
    var i = 0;
    // recalculate the sort order
    for (let d of this.newDashboardList.dashboards) {
        i++;
        d.index = i;
    }
    this.listservice.update(this.newDashboardList).subscribe(d => {
      this.toasterService.success('New Dashboard List Updated');
    });
    console.log("Updated Dashboard List", this.newDashboardList);
  }

  public deleteDashboardList(){
    if (confirm("Are you sure you want to permenantly delete this Dashboard List?")){
      this.dashboardListService.DashboardListRemoveDashboardList({customerId:this.app.customerId, dashboardListId: this.newDashboardList.dashboardListId}).subscribe(d => {
        this.toasterService.success('New Dashboard List Deleted');
        this.addDashboardList.hide();
        this.listservice.get(this.app.customerId);
      });
    }
  }

  removeDashboardListItem(index){
    console.log(index);
    this.newDashboardList.dashboards.splice(index, 1);
  }

  dashboardToAdd: any;

  addDashboardToList(id){
    var dashboard = this.sourceDashboardList.find(d => d.dashboardId == id);
    this.newDashboardList.dashboards.push(dashboard);
    this.newDashboardList.dashboards = this.newDashboardList.dashboards.slice();
    console.log(this.newDashboardList.dashboards);
  }

  removeDashboard(dashboard){
    var index = this.newDashboardList.dashboards.indexOf(dashboard);
    this.newDashboardList.dashboards.splice(index, 1);
    this.newDashboardList.dashboards = this.newDashboardList.dashboards.slice();

  }
  
}
